var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 9.03366L0.5 5.36699L1.78333 4.08366L4.16667 6.46699L10.2167 0.416992L11.5 1.70033L4.16667 9.03366Z",
    fill: "#047857"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckSmall);
export default __webpack_public_path__ + "static/media/green_check_small.0e68144c6793ad700b34a93d239cdfd0.svg";
export { ForwardRef as ReactComponent };